import React from 'react';
import StandardPage from './pages/standard-page';

function PageNotFound() {
  return (
    <StandardPage>
      There is nothing here. Maybe it bought Sonic and flew away!
    </StandardPage>
  );
}

export default PageNotFound;
